import Logo from '@/assets/images/3-scratch-the-code.png';
import { WORDS } from '@/components/Step3/config';
import BorderImage from '@/assets/images/2-circles-dashes.svg';
import { type PointerEvent, useEffect, useRef } from 'react';

const SCRATCH_RADIUS = 24;

export const ClueStep3 = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const isDrawing = useRef(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;

    ctx.fillStyle = '#C8981E';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }, []);

  const scratchAt = (clientX: number, clientY: number) => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;

    const rect = canvas.getBoundingClientRect();
    const x = ((clientX - rect.left) / rect.width) * canvas.width;
    const y = ((clientY - rect.top) / rect.height) * canvas.height;
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.arc(x, y, SCRATCH_RADIUS, 0, Math.PI * 2);
    ctx.fill();
  };

  const onPointerDown = (event: PointerEvent) => {
    isDrawing.current = true;
    (event.target as HTMLCanvasElement).setPointerCapture(event.pointerId);
    scratchAt(event.clientX, event.clientY);
  };
  const onPointerMove = (event: PointerEvent) => {
    if (!isDrawing.current) return;
    scratchAt(event.clientX, event.clientY);
  };
  const onPointerUp = () => {
    isDrawing.current = false;
  };

  return (
    <div
      className="bg-black rounded-lg p-2 flex flex-col gap-8 w-72 max-w-2/3 drop-shadow-white drop-shadow-[0_0_40px] border-image-dashed border-24"
      style={{
        borderImageSource: `url("${BorderImage}")`,
      }}
    >
      <img src={Logo} alt="Scratch the Code" className="h-auto w-full py-6 px-2" />

      <div className="w-full aspect-2/1 bg-white rounded p-4 flex flex-col justify-evenly relative overflow-hidden">
        {WORDS.filter(w => !w.hiddenInBackground).map(word => (
          <span key={word.id} className="font-bold text-lg text-black odd:self-start even:self-end">
            {word.id}. {word.word}
          </span>
        ))}

        <canvas
          ref={canvasRef}
          width={400}
          height={200}
          className="absolute inset-0 w-full h-full cursor-crosshair touch-none"
          onPointerDown={onPointerDown}
          onPointerMove={onPointerMove}
          onPointerUp={onPointerUp}
          onPointerLeave={onPointerUp}
        />
      </div>
    </div>
  );
};
